module.exports = __webpack_public_path__ + "static/img/new_kl8.b1e36c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_kl8.png
// module id = vAPw
// module chunks = 101